export const DEFAULT_STATUSES = ['Open', 'Pending', 'In Progress', 'Waiting on Customer'];

export const STATUS_OPTIONS = [
  'Open',
  'Pending',
  'Closed',
  'In Progress',
  'Waiting on Customer',
  'Waiting on Third Party'
];

export const PRIORITY_OPTIONS = ['Low', 'Medium', 'High', 'Critical', 'Urgent'];
export const CASE_TYPE_OPTIONS = ['Bug Report', 'Feature Request', 'Technical Support', 'Account Issue', 'Other'];
